import styled, { keyframes, css } from 'styled-components';
import { sizes } from 'style';

export const StyledQAItem = styled.div`
  position: relative;
  padding-left: 20px;

  @media ${sizes.tabletPortrait} {
    padding-left: 30px;
  }

  .highlight {
    display: inline-block;
    position: relative;
    white-space: pre;

    ::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: -1px;
      right: -1px;
      bottom: 0;
      background-color: ${({ theme }) => theme.colors.yellow}CC;
      z-index: 0;
    }
  }

  .highlighted-content {
    position: relative;
  }

  > h4 {
    margin: 0;
    padding-bottom: ${(props) => (props.showAnswer ? '0' : '30px')};
    user-select: none;
    cursor: pointer;
    font-size: 18px;
    line-height: 1.6;

    @media ${sizes.desktop} {
      padding-bottom: ${(props) => (props.showAnswer ? '0' : '60px')};
    }

    > svg {
      position: absolute;
      left: -2px;
      top: 6px;
      font-size: 17px;
      filter: ${({ showAnswer }) =>
        showAnswer
          ? 'drop-shadow(0px -1px 1px #00000029)'
          : 'drop-shadow(0px 1px 1px #00000029)'};
      transition: transform 0.2s;
      transform: ${({ showAnswer }) => (showAnswer ? 'rotate(180deg)' : 'rotate(0deg)')};

      @media ${sizes.tabletPortrait} {
        top: 3px;
        left: 0;
        font-size: 20px;
      }
    }
  }
`;

export const Answer = styled.div`
  opacity: 0;
  visibility: hidden;
  height: 0;
  line-height: 1.6;
  overflow: hidden;

  ${({ showAnswer }) =>
    showAnswer &&
    css`
      opacity: 1;
      visibility: visible;
      height: auto;
      padding: 20px 0 50px 0;
      overflow: initial;

      animation-name: ${keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  `};
      animation-duration: 200ms;
      animation-timing-function: ease-in-out;
    `}

  > * {
    margin: 0;
    &:not(:last-child):not(ul) {
      margin-bottom: 20px;
    }
  }

  > :first-child {
    padding: 0;
  }

  /*
    select all lists in rich text within section
    that are next to a paragraph (div) and reduce the
    space between the paragraph and the list
  */
  > div + ul {
    margin-top: -20px;
  }

  a {
    color: ${({ theme }) => theme.colors.turquoise};
  }

  ul {
    padding-left: 24px;
  }

  ul > li {
    list-style-type: none;
    position: relative;

    ::before {
      content: ' ';
      position: absolute;
      top: 11px;
      left: -14px;
      width: 3.5px;
      height: 3.5px;
      background-color: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const SmallPrint = styled.div`
  font-size: 13px;
  white-space: pre-line;
`;

export const Warning = styled.div`
  padding: 10px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.lightYellow};
  color: ${({ theme }) => theme.colors.red};
  font-weight: bold;

  > * {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;
